import { GENERAL_ELECTRIC_JSON_IMPORT } from '@/constants/featureFlags';
import { GENERAL_ELECTRIC } from '@/constants/integrationTypes';

export const JSON_IMPORT_TYPES = [{ flag: GENERAL_ELECTRIC_JSON_IMPORT, type: GENERAL_ELECTRIC }];

export const getJsonImportType = (circles = {}) => JSON_IMPORT_TYPES.find(({ flag }) => circles?.[flag])?.type;

export const canImportJson = (circles = {}) => JSON_IMPORT_TYPES.some(({ flag }) => !!circles?.[flag]);
